import { produce } from 'immer'
import { resetPasswordRouteProps } from 'src/navigation/routeProps'
import {
  POST_AUTH_FLOW_TYPE_FAILURE,
  POST_COGNITO_RESET_PASSWORD_INIT_FAILURE,
  POST_COGNITO_RESET_PASSWORD_INIT_INIT,
  POST_COGNITO_RESET_PASSWORD_INIT_SUCCESS,
  POST_RESET_PASSWORD_FAILURE,
  POST_RESET_PASSWORD_INIT,
  POST_RESET_PASSWORD_SUCCESS,
  PostAuthFlowTypeActions,
  PostCognitoResetPasswordInitActions,
  PostResetPasswordActions,
  RESET_PASSWORD_RESET_STATE,
} from 'src/redux/actions/auth.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface ResetPasswordState {
  emailSending: boolean
  emailSent: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: ResetPasswordState = {
  emailSending: false,
  emailSent: false,
}

export type Actions =
  | PostResetPasswordActions
  | PostAuthFlowTypeActions
  | PostCognitoResetPasswordInitActions

const CoreResetPasswordReducer = (
  state = initialState,
  action: Actions,
): ResetPasswordState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case POST_COGNITO_RESET_PASSWORD_INIT_INIT:
      case POST_RESET_PASSWORD_INIT: {
        draft.emailSending = true
        draft.emailSent = false
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }

      case POST_COGNITO_RESET_PASSWORD_INIT_SUCCESS:
      case POST_RESET_PASSWORD_SUCCESS: {
        draft.emailSending = false
        draft.emailSent = true
        return draft
      }

      case RESET_PASSWORD_RESET_STATE: {
        draft.emailSending = false
        draft.emailSent = false
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }

      case POST_COGNITO_RESET_PASSWORD_INIT_FAILURE:
      case POST_AUTH_FLOW_TYPE_FAILURE:
      case POST_RESET_PASSWORD_FAILURE: {
        draft.emailSending = false
        draft.emailSent = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const ResetPasswordReducer = createBackgroundReducer(
  resetPasswordRouteProps,
  initialState,
  CoreResetPasswordReducer,
)

export default ResetPasswordReducer
